import './Footer.css';
import React from "react";
import aiFreeCommitment from '../assets/images/aiFreeCommitment.png'
import { Link } from 'react-router-dom';


function Footer() {

    return (
        <div class="footer">
            <footer className="footerContainer">
                <nav>
                    <h1 className="footerHeader"> SITE NAVIGATOR</h1>
                    <ul className="navItemList">
                        <li><Link className="navItem" to="/">Home</Link></li>
                        <li><Link className="navItem" to="/stories">Stories</Link></li>
                        <li><Link className="navItem" to="/type">Typography</Link></li>
                        <li><Link className="navItem" to="/brands">Brand Work</Link></li>
                        <li><Link className="navItem" to="/creative-calisthenics">Creative Calisthenics</Link></li>
                        <li><Link className="navItem" to="/ai-free">AI Free Commitment</Link></li>
                    </ul>
                </nav>
                <div className="footerBottom">
                    <p className="footerText"> © 2026 Cerasus Creative Studios LLC </p>
                    <p className="footerSubText"> All rights reserved. The material on this site, including but not limited to photography, graphics, and writings, may not be reproduced, distributed, transmitted, cached, or otherwise used without the prior written permission of Cerasus Creative Studios.</p>
                </div>
                    <a href="https://cerise-technology.com/ai-free-commitment" >
                  <img src={aiFreeCommitment} alt="certified generative AI free - click to learn more about our commitment" className="aiFreeCommitmentImage"/>
                </a>
            </footer>
        </div>
    )
}

export default Footer;